export const  uvStoreConstants = {
    GET_STORE_SUCCESS:  'GET_STORE_SUCCESS',

    CHANGE_ADMIN_STATUS_REQUEST:  'CHANGE_ADMIN_STATUS_REQUEST',
    CHANGE_ADMIN_STATUS_SUCCESS: 'CHANGE_ADMIN_STATUS_SUCCESS',
    CHANGE_ADMIN_STATUS_FAILURE: 'CHANGE_ADMIN_STATUS_FAILURE',

    GET_MARKETPLACE_LIST_SUCCESS : "GET_MARKETPLACE_LIST_SUCCESS"
};